import Image from 'next/image';
import _ from 'lodash';

const SpeakerAvatar = ({ avatar, name, useNewAvatar = false }) => {
  if (useNewAvatar) {
    const avatarSrc = `/static/images/transform/speakers_temp/portrait_${_.snakeCase(name)}.jpg`;

    return (
      <div className="relative z-10 h-56 ">
        <Image src={avatarSrc} layout="fill" objectFit="cover" quality={100} />
      </div>
    );
  }

  return (
    <div className="relative z-10 rounded-md rounded-b-none">
      <div className="p-8">
        <Image
          src={avatar.url}
          width={400}
          height={400}
          objectFit="cover"
          quality={100}
          className="bg-white rounded-full"
        />
      </div>
    </div>
  );
};

export default SpeakerAvatar;
